// extracted by mini-css-extract-plugin
export var ClearButton = "ResetButton-module--ClearButton--wH01x";